// ============================================================
// Datei: src/components/modals/PublicSlotsModal.jsx
// Zweck: Eingabe der Anzahl Public Slots
// ============================================================

import React, { useState } from "react";
import "../../styles/modal.css"; // Falls du ein Modal-CSS hast

const PublicSlotsModal = ({ maxSlots, onSubmit, onCancel }) => {
    const [value, setValue] = useState(0);

    const handleConfirm = () => {
        const num = parseInt(value, 10);
        if (isNaN(num) || num < 0 || num > maxSlots) return;
        onSubmit(num);
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Schichten veröffentlichen</h2>

                <p>max. {maxSlots}</p>

                <input
                    type="number"
                    min="0"
                    max={maxSlots}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    className="modal-input"
                />

                <div className="modal-buttons">
                    <button className="modal-btn cancel" onClick={onCancel}>
                        Abbrechen
                    </button>
                    <button className="modal-btn confirm" onClick={handleConfirm}>
                        Publizieren
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PublicSlotsModal;
